import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { CopilotMessage, CopilotStep } from './lib/copilotTypes'
import MessageBubble from './MessageBubble'
import TraceSteps, { ThinkingDots } from './TraceSteps'
import styles from './index.module.scss'

interface MessageListProps {
  messages: CopilotMessage[]
  steps: CopilotStep[]
  thinking: boolean
}

const MessageList: React.FC<MessageListProps> = ({ messages, steps, thinking }) => {
  const { t } = useTranslation()
  const endRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (endRef.current) endRef.current.scrollIntoView({ block: 'end' })
  }, [messages, steps, thinking])

  let lastAssistantId: string | undefined
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'assistant') {
      lastAssistantId = messages[i].id
      break
    }
  }

  const greeting: CopilotMessage = { id: 'greeting', role: 'assistant', text: t('genAI.copilot-greeting') }

  return (
    <div className={styles.msgs}>
      <MessageBubble message={greeting} />
      {messages.map((m) => (
        <MessageBubble key={m.id} message={m} fresh={m.id === lastAssistantId} />
      ))}
      {thinking && (steps.length > 0 ? <TraceSteps steps={steps} /> : <ThinkingDots />)}
      <div ref={endRef} />
    </div>
  )
}

export default MessageList
